import React, { useState, useEffect } from 'react'
import styles from './Currency.module.less'
import { utils } from '@/utils'

interface CurrencyProps {
  currencyUnit: string
  money: number
  precision: number
  unitSize: number
  prefixText?: string
  strongNum?: boolean
  moneySize: number
}

const { formatByPrecision, px2rem } = utils

const Currency: React.FC<CurrencyProps> = ({
  currencyUnit = '$',
  money = 0,
  precision = 0,
  unitSize = 24,
  prefixText = '',
  strongNum = true,
  moneySize = 28
}) => {
  const [formatMoney, setFormatMoney] = useState('')

  const unitStyles = {
    fontSize: px2rem(unitSize)
  }

  const moneyStyles = {
    fontSize: px2rem(moneySize)
  }

  function updateFormatMoney() {
    setFormatMoney(String(formatByPrecision(money, precision)))
  }

  useEffect(() => {
    updateFormatMoney()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [money])

  return (
    <div className={styles['kp-currency']}>
      <span className={styles['kp-des']}>{prefixText}</span>
      <span className={`${styles['kp-currency-unit']} ${strongNum ? styles['strong-num'] : '' }`} style={unitStyles}>{currencyUnit}</span>
      <span className={`${styles['kp-currency-money']} ${strongNum ? styles['strong-num'] : '' }`} style={moneyStyles}>{formatMoney}</span>
  </div>
  )
}

export default Currency